import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Provider } from 'react-redux';
import { IonApp, isPlatform, setupConfig } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { store } from './app/store';
import { PrivateRoute } from './app/containers/PrivateRoute';
import { App } from './app/index';
import SplashHOC from './app/components/app/hoc/splash/SplashHOC';
import pageNotFound from './app/components/app/hoc/pageNotFound/PageNotFound';
import { GPSWrapper } from './app/utils/common';
import { initFirebaseWeb } from './app/utils/Analytics';
import { ErrorBoundary } from "react-error-boundary";
import './i18n';
import { handleAdjustDeepLinkWeb, readAndStoreDynamicLinkAttributes, readAndStoreDynamicLinkAttributesWeb } from './app/utils/DynamicLink.util';
import { logError } from 'app/utils/ErrorBoundaryLogs'
import { initAdjust } from 'app/utils/Adjust.util';


const AppContainer: React.FC = () => {
  setupConfig({swipeBackEnabled:false});

  // Initialize Firebase and Adjust
  if (isPlatform("capacitor")) {
    initAdjust();
    readAndStoreDynamicLinkAttributes();
    GPSWrapper.details.initiateGPSconfig();
  } else {
    const currentURL = window && window.location.href;
    initFirebaseWeb();
    handleAdjustDeepLinkWeb(currentURL);
    readAndStoreDynamicLinkAttributesWeb(currentURL);
  }
  
  return (
    <SplashHOC WrappedComponent={
      <ErrorBoundary FallbackComponent={pageNotFound} onError={logError}>
        <Provider store={store}>
          <IonApp>
            <PrivateRoute component={App} />
          </IonApp>
        </Provider>
      </ErrorBoundary>
    } />
  );
};

ReactDOM.render(
  <Suspense fallback="Loading...">
    <AppContainer />
  </Suspense>,
  document.getElementById('root')
);
defineCustomElements(window);